export type SessionRecoveryEvent = {
  name:
    | 'refresh_started'
    | 'refresh_succeeded'
    | 'refresh_missing_credentials'
    | 'refresh_rejected'
    | 'refresh_failed'
    | 'refresh_invalid_response'
    | 'refresh_discarded'
    | 'refresh_unavailable'
    | 'retry_rejected'
    | 'cleanup_started'
    | 'cleanup_succeeded'
    | 'cleanup_failed'
    | 'redirect_requested'
    | 'redirect_failed';
  httpStatus?: number;
  reason?: 'http' | 'transport' | 'unexpected';
  trigger?: 'session_expiry' | 'manual_logout';
};

export const sessionRecoveryLevels: Record<
  SessionRecoveryEvent['name'],
  'info' | 'warning' | 'error'
> = {
  refresh_started: 'info',
  refresh_succeeded: 'info',
  refresh_missing_credentials: 'warning',
  refresh_rejected: 'warning',
  refresh_failed: 'error',
  refresh_invalid_response: 'error',
  refresh_discarded: 'info',
  refresh_unavailable: 'error',
  retry_rejected: 'error',
  cleanup_started: 'info',
  cleanup_succeeded: 'info',
  cleanup_failed: 'error',
  redirect_requested: 'info',
  redirect_failed: 'error',
};

export function logSessionRecovery(event: SessionRecoveryEvent) {
  const level = sessionRecoveryLevels[event.name];
  if (level === 'error') console.error('[Session Recovery]', event);
  else if (level === 'warning') console.warn('[Session Recovery]', event);
  else console.info('[Session Recovery]', event);
}
